var _ = require('lodash');
var Backbone = require('backbone');
module.exports = _.extend({}, Backbone.Events);



//////////////////
// WEBPACK FOOTER
// ./node_modules/tscom-pubsub/src/lib/index.js
// module id = 14
// module chunks = 0